var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg18(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 78,
    viewBox: "0 0 51 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4628 0.195312C21.7956 2.2038 16.3247 8.06718 11.0512 17.783C3.14153 32.3592 -7.07642 53.0705 6.99276 69.47C13.5009 77.0554 24.2477 81.5331 38.3511 74.4425C49.6817 68.7448 52.8334 52.3954 48.7652 44.7136C40.3742 28.8663 31.8612 24.9578 29.5822 15.1298C28.0624 8.57784 27.3555 3.60048 27.4616 0.195312H27.4628Z",
    fill: "url(#paint0_linear_391_28654)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4639 0C21.7675 2.02921 16.2977 7.89259 11.0523 17.5877C3.18526 32.1322 -7.07535 52.8752 6.99383 69.2747C13.5019 76.8601 24.1111 79.311 29.9976 74.8126C33.8355 71.8791 36.4448 69.0833 37.9487 63.1919C39.6233 56.6326 38.3387 47.8004 37.4576 43.7444C36.3436 38.6098 35.9792 32.9756 36.3644 26.8404C36.2627 26.717 36.1611 26.5935 36.0597 26.4699C32.9957 22.7186 30.6314 19.4524 29.5833 14.9345C28.0635 8.38252 27.3566 3.40517 27.4626 0L27.4639 0Z",
    fill: "url(#paint1_linear_391_28654)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7449 2.55273C17.4397 6.74521 13.4947 13.7774 10.9109 23.6492C7.03531 38.4582 6.61606 52.1142 7.9835 60.058C10.633 75.4556 24.3707 81.3007 38.4606 74.1345C47.132 69.7226 50.7444 60.2554 50.553 49.979C50.3544 39.3369 29.7917 27.2774 26.1501 18.3976C23.7224 12.477 22.5877 7.19493 22.7449 2.55273Z",
    fill: "url(#paint2_linear_391_28654)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1972 30.3145C42.5591 38.474 43.946 44.1545 40.3568 47.355C34.9748 52.1556 21.8112 55.2878 13.6224 49.4805C8.16244 45.6085 6.09667 37.304 7.4251 24.5645C5.20064 29.1984 3.29101 33.9769 1.70919 38.8676C0.151636 43.6963 -0.304175 48.7492 0.344197 54.0264C2.29662 57.9751 7.0412 60.6113 14.5791 61.9372C25.8891 63.9262 36.5897 62.9427 43.7717 59.323C48.5602 56.9099 50.8246 54.5066 50.5662 52.1154C50.7381 48.5835 49.6497 45.2222 47.2988 42.0291C44.9466 38.8359 41.2465 34.9323 36.196 30.3133L36.1972 30.3145Z",
    fill: "url(#paint3_linear_391_28654)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3342 22.168C11.2806 28.0606 12.7955 33.6619 15.8789 38.9745C20.5041 46.9402 25.9031 54.8108 33.9822 61.336C39.369 65.6869 43.6724 67.0909 46.8935 65.5528C44.2489 70.2876 41.4336 72.6081 38.4537 72.5131C33.9822 72.3717 28.5307 70.4168 19.7948 59.9198C13.9716 52.9218 9.98752 46.3015 7.84375 40.0604C8.18378 37.5839 8.54453 35.1183 8.92478 32.6626C9.30624 30.2056 10.1094 26.7078 11.333 22.168H11.3342Z",
    fill: "url(#paint4_linear_391_28654)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9978 30.2532C25.4927 35.055 27.3598 42.7331 24.9978 47.8457C22.6359 52.9584 11.7257 62.194 14.736 70.3316C17.7488 78.4667 25.088 76.641 29.6924 72.8909C34.2969 69.1409 36.7612 63.0435 37.3072 58.7559C37.8532 54.4684 36.0007 46.2187 35.3974 39.0415C34.9952 34.258 35.2682 30.1569 36.2152 26.7359L34.8051 24.9614L26.5006 22.502C25.1697 24.4702 24.6688 27.054 24.9978 30.2532Z",
    fill: "url(#paint5_linear_391_28654)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9581 6.47852C25.2708 7.61439 22.7249 9.86419 20.3191 13.2291C16.7116 18.276 14.8737 21.3021 16.2338 31.3068C17.1406 37.977 17.7902 44.1133 18.1814 49.7159L29.8119 15.9238C29.4242 14.3762 29.0687 12.8207 28.7455 11.2584C28.4291 9.67448 28.1665 8.08026 27.9581 6.47852Z",
    fill: "url(#paint6_linear_391_28654)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7911 15.8567C26.8381 17.58 24.5505 21.1095 22.9272 26.4476C21.305 31.7857 19.8194 39.248 18.4727 48.8359C20.2691 42.7373 21.461 38.3218 22.0472 35.5857C22.9272 31.4834 23.2282 25.681 25.5657 21.742C27.1233 19.1156 28.5322 17.1547 29.7911 15.8555V15.8567Z",
    fill: "#330A4C",
    fillOpacity: 0.316
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1211 73.0488C20.979 73.7435 23.5201 74.3602 23.7431 74.9013C24.0771 75.7106 23.1277 76.4516 20.4306 75.9531C18.6329 75.6216 17.196 74.6527 16.1211 73.0488Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5635 6.47852C15.8908 9.67163 13.5751 13.0561 11.6166 16.6319C9.6581 20.2077 8.25655 22.8779 7.41683 24.6378C7.15602 25.9504 7.02927 27.887 7.03537 30.4476C7.04146 33.0094 7.26327 35.8576 7.69958 38.991C8.07216 32.9043 9.25334 26.8943 11.212 21.1193C13.1717 15.3424 15.6214 10.4614 18.5635 6.47852Z",
    fill: "#EDEDED",
    fillOpacity: 0.603
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_28654",
    x1: 26.3695,
    y1: 5.94427,
    x2: 23.6634,
    y2: 77.9403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_28654",
    x1: 27.5929,
    y1: 5.92714,
    x2: -0.68758,
    y2: 67.9039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D67AF",
    stopOpacity: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_391_28654",
    x1: 30.7503,
    y1: 26.0088,
    x2: 30.7503,
    y2: 75.8495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26053D",
    stopOpacity: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B4B4",
    stopOpacity: 0.278
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_391_28654",
    x1: 5.17919,
    y1: 29.3782,
    x2: 17.8679,
    y2: 62.9892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91739F",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32054F",
    stopOpacity: 0.54
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_391_28654",
    x1: 39.0931,
    y1: 70.7067,
    x2: 4.20251,
    y2: 41.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463D49",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340A50",
    stopOpacity: 0.821
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_391_28654",
    x1: 31.9218,
    y1: 26.4768,
    x2: 7.31313,
    y2: 63.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#715383",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0.234
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_391_28654",
    x1: 34.2711,
    y1: 37.8968,
    x2: 16.844,
    y2: 36.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A1A8",
    stopOpacity: 0.356
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370C50",
    stopOpacity: 0.582
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg18);
export default __webpack_public_path__ + "static/media/img18.3587070ed736d858e3a9edc3223ce9bc.svg";
export { ForwardRef as ReactComponent };